import ApiService from './api.service'

const BoosterService = {
  async boosters(page = 1, search = '') {
    try {
      const query = new URLSearchParams({ page: String(page) })
      const trimmedSearch = String(search || '').trim()
      if (trimmedSearch) {
        query.set('search', trimmedSearch)
      }
      return await ApiService.get(`boosters?${query.toString()}`)
    } catch (error) {
      return error
    }
  },
  async activeInactive(id) {
    try {
      return await ApiService.put(`boosters/active/${id}`)
    } catch (error) {
      return error
    }
  },
  async inactiveUserBoosters(userId) {
    try {
      return await ApiService.get(`users/inactive/boosters/${userId}`)
    } catch (error) {
      return error
    }
  },
  async boostersPreview() {
    try {
      return await ApiService.get(`users/boosters/approve`)
    } catch (error) {
      return error
    }
  },

  async activeBoostersForUser(data) {
    try {
      return await ApiService.put(`users/active/boosters/${data.userId}?boosterId=${data.boosterId}`)
    } catch (error) {
      return error
    }
  },

  async fetchUserBoosterSelect(userId) {
    try {
      return await ApiService.get(`users/boosters/list/${userId}`)
    } catch (error) {
      return error
    }
  },

  async calculateBoosters(id) {
    try {
      return await ApiService.post(`user/boosters/import/${id}`)
    } catch (error) {
      return error
    }
  },

  async updateBoosterCronStatus(id, status, date) {
    try {
      const params = new URLSearchParams({ status })
      if (date) {
        params.append('date', date)
      }
      return await ApiService.put(`users/boosters/${id}/status?${params}`)
    } catch (error) {
      return error
    }
  },

  async boosterFields() {
    try {
      return await ApiService.get('boosters/fields')
    } catch (e) {
      return e.response
    }
  },

  async createBooster(data) {
    try {
      return await ApiService.post('boosters/create', data)
    } catch (e) {
      return e.response
    }
  },

  async deleteBoosterPoints(id) {
    try {
      return await ApiService.delete(`boosters/points/${id}/delete`)
    } catch (error) {
      return error
    }
  },

  async booster(id) {
    try {
      return await ApiService.get(`booster/${id}`)
    } catch (error) {
      return error
    }
  },

  async updateBooster(data) {
    try {
      return await ApiService.put(`booster/${data.id}/update`, data)
    } catch (error) {
      return error
    }
  },

  async validateIpcs(ipcNumbers) {
    try {
      return await ApiService.post('ipc/validate', { ipc: ipcNumbers })
    } catch (e) {
      return e.response
    }
  }
}

export { BoosterService }
